import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { TaskStatus } from '@/types';

interface StatusBadgeProps {
  status: TaskStatus;
  size?: 'small' | 'medium';
}

const statusConfig: Record<TaskStatus, { label: string; color: ChipProps['color'] }> = {
  [TaskStatus.NOT_STARTED]: {
    label: 'Not Started',
    color: 'default',
  },
  [TaskStatus.IN_PROGRESS]: {
    label: 'In Progress',
    color: 'primary',
  },
  [TaskStatus.BLOCKED]: {
    label: 'Blocked',
    color: 'error',
  },
  [TaskStatus.COMPLETED]: {
    label: 'Completed',
    color: 'success',
  },
  [TaskStatus.CANCELLED]: {
    label: 'Cancelled',
    color: 'default',
  },
};

/**
 * StatusBadge Component
 * Visual indicator for task status
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status] || {
    label: status || 'Unknown',
    color: 'default' as ChipProps['color'],
  };

  return (
    <Chip
      label={config.label}
      size={size}
      color={config.color}
      sx={{
        height: size === 'small' ? 24 : 28,
        fontSize: size === 'small' ? '0.75rem' : '0.8125rem',
        fontWeight: 500,
        '& .MuiChip-label': {
          px: 1.5,
        },
      }}
      variant="filled"
    />
  );
};

export default StatusBadge;
